import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'ChangeCustomFieldsController',
            ChangeCustomFieldsController
        );

    /** @ngInject */
    function ChangeCustomFieldsController(
        $scope,
        $state,
        $stateParams,
        CompaniesFactory,
        CustomFieldsService,
        ngDialog,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.issue = $scope.ngDialogData.issue;
            vm.save = save;
            vm.validationErrors = {};
        }

        function save() {
            CompaniesFactory.editIssue(
                $scope.ngDialogData.company,
                $stateParams.issue_id,
                {
                    custom_fields: CustomFieldsService.parseCustomFields(
                        vm.customFields
                    ),
                }
            ).then(
                function () {
                    toastr.success('Zapisano zmiany');
                    ngDialog.close();
                    $state.reload('company_employee.issue_list.details');
                },
                function (response) {
                    vm.validationErrors = response.data.custom_fields;
                    toastr.error('Wypełnij poprawnie formularz');
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/custom-fields/custom-fields.controller.ts